import React, { useState } from 'react';
import { StepContainer, StepNavigation, FormFieldGroup } from '../components';
import { StepProps, useFormContext } from '../context';

export const Step20G_Duvidas: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const { data, updateField } = useFormContext();
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleNext = () => {
    const newErrors: Record<string, string> = {};

    if (!data.doubtsQuestion) newErrors.doubtsQuestion = 'Campo obrigatório';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext({ doubtsQuestion: data.doubtsQuestion });
  };

  const handleFieldChange = (value: string) => {
    updateField('doubtsQuestion', value);
    if (errors.doubtsQuestion) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors.doubtsQuestion;
        return newErrors;
      });
    }
  };

  return (
    <StepContainer title="">
      <div className="space-y-6">
        <FormFieldGroup
          label="Você tem alguma dúvida sobre o nosso sistema de semijoias consignadas? Escreva abaixo.. (Caso não tenha dúvidas, escreva 'não')"
          required
          error={errors.doubtsQuestion}
        >
          <textarea
            value={data.doubtsQuestion || ''}
            onChange={(e) => handleFieldChange(e.target.value)}
            rows={3}
            placeholder="Descreva sua dúvida aqui..."
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </FormFieldGroup>

        <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
      </div>
    </StepContainer>
  );
};

export default Step20G_Duvidas;
